export default __webpack_public_path__ + "static/media/direct-inbox.03ec50f6.svg";